import {request} from "../request";

export const getPromotions = (page: string) =>
    request({
        url: `discount-companies/promotions?page=${page}`,
    });
